
import { testimonialsData } from '../../../mocks/testimonials';

const TestimonialsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-primary to-primary-dark">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            お客様の声
          </h2>
          <p className="text-white/90 text-lg">
            多くのお客様にご満足いただいています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {testimonialsData.map((testimonial) => (
            <article
              key={testimonial.id}
              className="bg-white rounded-3xl p-6 md:p-8 shadow-xl"
            >
              <div className="flex flex-col sm:flex-row gap-6">
                <div className="flex-shrink-0 mx-auto sm:mx-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-24 h-24 rounded-full object-cover"
                  />
                </div>
                <div className="flex-1 text-center sm:text-left">
                  <div className="text-6xl text-primary/20 leading-none mb-2">"</div>
                  <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-4">
                    {testimonial.comment}
                  </p>
                  <div className="space-y-2">
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.position}</p>
                    <div className="flex items-center justify-center sm:justify-start gap-1">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-primary text-lg"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
